import React from 'react';
import { Button, Modal } from 'react-bootstrap';

export function CancelAddBranch(props) {
  const {
    update,
    onHide,
    onSaveAndContinue,
    title = 'Close editing?',
    confirmLabel = 'Close',
    dismissLabel = 'Do not close',
    ...otherProps
  } = props;
  return (
    <Modal
      {...otherProps}
      onHide={onHide}
      size="md"
      className="deleteModal"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-center">
          Any unsaved changes will be lost.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="reset"
          variant={onSaveAndContinue ? 'light' : 'secondary'}
          onClick={onHide}
        >
          {dismissLabel}
        </Button>
        {onSaveAndContinue && (
          <Button
            type="submit"
            variant="outline-secondary"
            onClick={update}
          >
            {confirmLabel}
          </Button>
        )}
        {onSaveAndContinue ? (
          <Button
            type="button"
            variant="primary"
            onClick={onSaveAndContinue}
          >
            Save and continue
          </Button>
        ) : (
          <Button
            type="submit"
            variant="primary"
            onClick={update}
          >
            {confirmLabel}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
}
